import React from "react";
import Navbar from "./config/routes";


function App() {
  return <Navbar />;
} 

export default App;
